import React from "react";
import StatusBadge from "./StatusBadge";
import { formatPct, formatHMR, formatTemp } from "@/utils/formatters";

/**
 * MachineListDrillDown — renders any "list of machines" inside a DrillDownPanel.
 */
export default function MachineListDrillDown({ machines = [], emptyText = "No machines match this view." }) {
  if (!machines.length) {
    return (
      <p className="font-body text-sm text-muted" style={{ padding: "24px 0", textAlign: "center" }}>
        {emptyText}
      </p>
    );
  }

  return (
    <div>
      <p className="text-caps text-muted font-body" style={{ marginBottom: 12 }}>
        {machines.length} machine{machines.length !== 1 ? "s" : ""}
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {machines.map((m) => (
          <div
            key={m.machine_id || m.serial_number}
            className="glass-card-sm"
            style={{ padding: "12px 14px" }}
            data-testid={`drilldown-machine-${m.machine_id || m.serial_number}`}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
              <span className="font-body weight-semibold text-md text-primary">{m.machine_id || m.serial_number}</span>
              <StatusBadge status={(m.status || "active").toLowerCase()} />
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 14, marginTop: 4 }}>
              <span className="text-xs text-muted font-body">
                Fuel: <strong className="text-primary">{formatPct(m.fuel_pct)}</strong>
              </span>
              <span className="text-xs text-muted font-body">
                Temp: <strong className="text-primary">{formatTemp(m.temp_c)}</strong>
              </span>
              <span className="text-xs text-muted font-body">
                HMR: <strong className="text-primary">{formatHMR(m.total_hmr ?? m.machine_hours)}</strong>
              </span>
              <span className="text-xs text-muted font-body">
                Util: <strong className="text-primary">{formatPct(m.utilization_pct)}</strong>
              </span>
              <span className="text-xs text-muted font-body">
                {m.city || m.site_name || "—"}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
